import { searchHints, searchHots } from '@/api/modules/search';
const search = {
    namespaced: true,
    state: () => {
        return {
            // 热词搜索
            searchHotTexts: [],
            // 底纹词
            searchHintsText: '',
            // 搜索记录
            searchhistory: localStorage.getItem('histroy') ? JSON.parse(localStorage.getItem('histroy') || '[]') : []
        };
    },
    mutations: {
        // 底纹
        SET_HINTS_TEXT: (state, text) => {
            state.searchHintsText = text;
        },
        // 搜索热词
        SET_HOT_TEXT: (state, texts) => {
            state.searchHotTexts = texts;
        },
        // 删除历史记录
        CLEAR_HISTORY: (state) => {
            state.searchhistory.splice(0);
            localStorage.removeItem('histroy');
        },
        // 更新搜索历史记录
        UPDATE_HISTORY: (state, searchValue) => {
            // 先找有没有存在,存在挪到第一位
            const index = state.searchhistory.findIndex((item) => item === searchValue);
            if (index !== -1) {
                const [item] = state.searchhistory.splice(index, 1);
                state.searchhistory.unshift(item);
            }
            else {
                // 不存在
                // 判断是否超出10个 超出十个 删除最后一个,将新的推到前面
                if (state.searchhistory.length < 10) {
                    state.searchhistory.unshift(searchValue);
                }
                else {
                    state.searchhistory.pop();
                    state.searchhistory.unshift(searchValue);
                }
            }
            localStorage.setItem('histroy', JSON.stringify(state.searchhistory));
        }
    },
    actions: {
        // 热词
        getHotsText({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                const params = {
                    size: 6,
                    phone: rootState.ringtone.phone
                };
                searchHots(params).then((res) => {
                    commit('SET_HOT_TEXT', res.data);
                    resolve(res.data);
                }).catch(err => {
                    reject(err);
                });
            });
        },
        // 搜索底纹
        getHintsText({ commit, rootState }) {
            const params = {
                phone: rootState.ringtone.phone
            };
            searchHints(params).then((res) => {
                if (res.data && res.data.length > 0) {
                    const hints = res.data.shift();
                    commit('SET_HINTS_TEXT', hints.hint);
                }
            });
        }
    }
};
export default search;
